/**
 * @module FE-CU42_緊急連絡先設定画面_コンポーネント
 */
export function firstNameClass() {
  return { alert: this.error.firstContact.hasNameError };
}

export function firstNameKanaClass() {
  return { alert: this.error.firstContact.hasNameKanaError };
}

export function firstRelationshipClass() {
  return { alert: this.error.firstContact.hasRelationshipError };
}

export function firstPhoneNumberClass() {
  return { alert: this.error.firstContact.hasPhoneNumberError };
}
